const autoHeight = () => {

    var windowWidth = $(window).width();
    var windowSm = 767;
    
    let elem = document.getElementsByClassName('heightchesk')
    // let elemChildren = elem.children;
    let elemMaxHeight = 0;
    let elemArray = new Array;
    
    if (windowWidth >= windowSm) {
        Array.prototype.forEach.call(elem, function(elemImg) {
            //子要素の高さのスタイルを初期化（リサイズ対応用）
            elemImg.style.height = '';
            elemArray.push(elemImg.clientHeight);
        });

        elemMaxHeight = Math.max.apply(null, elemArray);
        Array.prototype.forEach.call(elem, function(elemImg) {
            elemImg.style.height = elemMaxHeight + 'px';
        });
    }

}

//ロードとリサイズ時に関数autoHeightを実行
window.addEventListener('resize', autoHeight);
window.addEventListener('load', autoHeight);